import { Component, OnInit } from "@angular/core";
import { Data, Router } from "@angular/router";
import { ModalController, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { SyndicateRepositoryService } from "../../syndicate-repository.service";
import { HeaderComponent } from "../../../../components/header/header.component";

@Component({
    selector: "app-was-not-aware",
    templateUrl: "./was-not-aware.component.html",
    styleUrls: ["./was-not-aware.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        TranslatePipe,
    ],
})
export class WasNotAwareComponent implements OnInit {
  pageTitle = "Leave syndicate";
  reason = "wasnot-aware";
  syndicateName: Data | string;

  constructor(
    public translate: TranslateService,
    private modalCtrl: ModalController,
    private GTMSegment: GTMSegmentService,
    private router: Router,
    private syndicateService: SyndicateRepositoryService,
  ) {
    this.GTMSegment.GTMPopupInitialization("leaveSyndicateReasonPopup-5");
  }

  ngOnInit() {
    this.translate.get(['was-not-aware.pageTitle']).subscribe((res: string) => {
      this.pageTitle = (res["was-not-aware.pageTitle"])
    }, err => { return (err) })
  }


  backToLeaveSyndicate() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }

  leave() {
    this.modalCtrl.dismiss(this.reason).catch(err => { return err });
  }

  closeAndRedirect() {
    this.router.navigateByUrl("/mainTabs/tabs/store");
    this.syndicateService?.closeAllDialogs();
  }
}
